import React from "react";

// Image \\
import qoshtirnoq from "../../assets/images/qo'shTirnoq.svg";

const CommentCard = () => {
  return (
    <div>
      <div className="cards">
        <div className="card_items">
          <div className="card_items_image">
            <img src={qoshtirnoq} alt="qoshtirnoq" />
          </div>

          <div className="text">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque tortor ornare ornare. Quisque placerat
              scelerisque felis vitae tortor augue. Velit nascetur Consequat
              faucibus porttitor enim et.
            </p>
          </div>

          <hr />

          <div className="auth">
            <p>John Doe</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CommentCard;
